import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import {useSettings} from '../../contexts/SettingsContext';

export default function LibraryCopiesPage(){
  const {settings}=useSettings();
  const config={
    title:'Library Copies',recordLabel:'Book Copy',createLabel:'Add Book Copy',
    subtitle:'Physical accession inventory with automatic accession number + Code 39 barcode generation, printable labels and live availability.',
    icon:'📚',collection:'libraryCopies',permission:'library',accent:'green',specialSave:'libraryCopy',barcodeMode:true,
    columns:['accessionNo','bookIdName','barcode','rack','condition','status'],
    fields:[
      {name:'bookId',label:'Book Title',type:'reference',referenceCollection:'libraryBooks',referenceLabel:'title',required:true,copyMeta:{isbn:'isbn',author:'author',publisher:'publisher'}},
      {name:'accessionNo',label:'Accession Number',help:'Leave blank to auto-generate according to Library Settings.'},
      {name:'barcode',label:'Barcode Value',help:'Leave blank to use the generated accession number as the barcode.'},
      {name:'rack',label:'Rack / Shelf'},
      {name:'purchaseDate',label:'Purchase Date',type:'date'},
      {name:'purchasePrice',label:'Purchase Price',type:'number'},
      {name:'condition',label:'Condition',type:'select',options:['New','Good','Fair','Damaged'],defaultValue:'Good'},
      {name:'status',label:'Status',type:'select',options:['available','issued','reserved','lost','damaged','inactive'],defaultValue:'available'}
    ]
  };
  if(settings.libraryPolicy?.usePhysicalCopies===false)return <div className="empty-panel">Physical copy tracking is disabled in Library Settings.</div>;
  return <InstituteCrudPage config={config}/>;
}
